// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IndySoft API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AddWorkOrderDetailCommand } from '../models';
// @ts-ignore
import type { CompleteWorkOrderCommand } from '../models';
// @ts-ignore
import type { IncompleteWorkOrderCommand } from '../models';
// @ts-ignore
import type { WorkOrderDetailSummaryDto } from '../models';
// @ts-ignore
import type { WorkOrderDetailViewModel } from '../models';
// @ts-ignore
import type { WorkOrderViewModel } from '../models';
/**
 * WorkOrdersApi - axios parameter creator
 * @export
 */
export const WorkOrdersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} globalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersDetailByGlobalIdGlobalIdGet: async (globalId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'globalId' is not null or undefined
            assertParamExists('apiWorkOrdersDetailByGlobalIdGlobalIdGet', 'globalId', globalId)
            const localVarPath = `/api/work-orders/detail/by-global-id/{globalId}`
                .replace(`{${"globalId"}}`, encodeURIComponent(String(globalId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CompleteWorkOrderCommand} [completeWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberCompletePost: async (jobNumber: string, completeWorkOrderCommand?: CompleteWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberCompletePost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/complete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(completeWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {AddWorkOrderDetailCommand} [addWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsPost: async (jobNumber: string, addWorkOrderDetailCommand?: AddWorkOrderDetailCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberDetailsPost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/details`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addWorkOrderDetailCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {IncompleteWorkOrderCommand} [incompleteWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberIncompletePost: async (jobNumber: string, incompleteWorkOrderCommand?: IncompleteWorkOrderCommand, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobNumber' is not null or undefined
            assertParamExists('apiWorkOrdersJobNumberIncompletePost', 'jobNumber', jobNumber)
            const localVarPath = `/api/work-orders/{jobNumber}/incomplete`
                .replace(`{${"jobNumber"}}`, encodeURIComponent(String(jobNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(incompleteWorkOrderCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkOrdersApi - functional programming interface
 * @export
 */
export const WorkOrdersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkOrdersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} globalId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersDetailByGlobalIdGlobalIdGet(globalId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDetailSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersDetailByGlobalIdGlobalIdGet(globalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersDetailByGlobalIdGlobalIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {CompleteWorkOrderCommand} [completeWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberCompletePost(jobNumber: string, completeWorkOrderCommand?: CompleteWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberCompletePost(jobNumber, completeWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberCompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {AddWorkOrderDetailCommand} [addWorkOrderDetailCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberDetailsPost(jobNumber: string, addWorkOrderDetailCommand?: AddWorkOrderDetailCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderDetailViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberDetailsPost(jobNumber, addWorkOrderDetailCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberDetailsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} jobNumber 
         * @param {IncompleteWorkOrderCommand} [incompleteWorkOrderCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWorkOrdersJobNumberIncompletePost(jobNumber: string, incompleteWorkOrderCommand?: IncompleteWorkOrderCommand, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkOrderViewModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWorkOrdersJobNumberIncompletePost(jobNumber, incompleteWorkOrderCommand, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkOrdersApi.apiWorkOrdersJobNumberIncompletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkOrdersApi - factory interface
 * @export
 */
export const WorkOrdersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkOrdersApiFp(configuration)
    return {
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersDetailByGlobalIdGlobalIdGet(requestParameters: WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailSummaryDto> {
            return localVarFp.apiWorkOrdersDetailByGlobalIdGlobalIdGet(requestParameters.globalId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberCompletePost(requestParameters.jobNumber, requestParameters.completeWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberDetailsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel> {
            return localVarFp.apiWorkOrdersJobNumberDetailsPost(requestParameters.jobNumber, requestParameters.addWorkOrderDetailCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel> {
            return localVarFp.apiWorkOrdersJobNumberIncompletePost(requestParameters.jobNumber, requestParameters.incompleteWorkOrderCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WorkOrdersApi - interface
 * @export
 * @interface WorkOrdersApi
 */
export interface WorkOrdersApiInterface {
    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersDetailByGlobalIdGlobalIdGet(requestParameters: WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailSummaryDto>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberDetailsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderDetailViewModel>;

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApiInterface
     */
    apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<WorkOrderViewModel>;

}

/**
 * Request parameters for apiWorkOrdersDetailByGlobalIdGlobalIdGet operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest
 */
export interface WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGet
     */
    readonly globalId: string
}

/**
 * Request parameters for apiWorkOrdersJobNumberCompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberCompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {CompleteWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberCompletePost
     */
    readonly completeWorkOrderCommand?: CompleteWorkOrderCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberDetailsPost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsPost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {AddWorkOrderDetailCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberDetailsPost
     */
    readonly addWorkOrderDetailCommand?: AddWorkOrderDetailCommand
}

/**
 * Request parameters for apiWorkOrdersJobNumberIncompletePost operation in WorkOrdersApi.
 * @export
 * @interface WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest
 */
export interface WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberIncompletePost
     */
    readonly jobNumber: string

    /**
     * 
     * @type {IncompleteWorkOrderCommand}
     * @memberof WorkOrdersApiApiWorkOrdersJobNumberIncompletePost
     */
    readonly incompleteWorkOrderCommand?: IncompleteWorkOrderCommand
}

/**
 * WorkOrdersApi - object-oriented interface
 * @export
 * @class WorkOrdersApi
 * @extends {BaseAPI}
 */
export class WorkOrdersApi extends BaseAPI implements WorkOrdersApiInterface {
    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersDetailByGlobalIdGlobalIdGet(requestParameters: WorkOrdersApiApiWorkOrdersDetailByGlobalIdGlobalIdGetRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersDetailByGlobalIdGlobalIdGet(requestParameters.globalId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberCompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberCompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberCompletePost(requestParameters.jobNumber, requestParameters.completeWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberDetailsPost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberDetailsPostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberDetailsPost(requestParameters.jobNumber, requestParameters.addWorkOrderDetailCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkOrdersApi
     */
    public apiWorkOrdersJobNumberIncompletePost(requestParameters: WorkOrdersApiApiWorkOrdersJobNumberIncompletePostRequest, options?: RawAxiosRequestConfig) {
        return WorkOrdersApiFp(this.configuration).apiWorkOrdersJobNumberIncompletePost(requestParameters.jobNumber, requestParameters.incompleteWorkOrderCommand, options).then((request) => request(this.axios, this.basePath));
    }
}

